import { login, logout, getinfo , binding} from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {router} from '@/router'

const state = {
  token: getToken(),
  id:'',
  sex: '',
  wx_name:'',
  avatar: '',
  phone:'',
  
	// 'id' : 1,
	// 'sex' : '男',
	// 'wx_name' : '铮蒸蒸',
	// 'phone' : '13533355099',
	// 'avatar' : 'http://thirdwx.qlogo.cn/mmopen/vi_32/dhdIq3JvLPy4CAZnlF2sCRNmaSSiaLxJcU160pKC9AXMQBWQostfeHgQRUZNyia7o68c2040hRlD60ItLLGa0gtg/132',
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ID: (state, id) => {
    state.id = id
  },
  SET_WXNAME: (state, wxname) => {
    state.wx_name = wxname
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_PHONE: (state, phone) => {
    state.phone = phone
  },
  SET_SEX: (state, sex) => {
    state.sex = sex
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { code, type } = userInfo
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        const { data } = response
        
        commit('SET_TOKEN', data.token)
        setToken(data.token)
		
		const { id, sex, head_img, phone, wx_name} = data.userinfo
		
		commit('SET_ID', id)
		commit('SET_SEX', sex)
		commit('SET_WXNAME', wx_name)
		commit('SET_AVATAR', head_img)
		commit('SET_PHONE', phone)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getinfo().then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { id, sex, head_img, phone, wx_name} = data.userinfo
        
        commit('SET_ID', id)
        commit('SET_SEX', sex)
        commit('SET_WXNAME', wx_name)
        commit('SET_AVATAR', head_img)
        commit('SET_PHONE', phone)
        
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  // //绑定信息
  // binding({ commit }, phoneform) {
  // 	return new Promise((resolve, reject) => {
  		
  // 		binding(phoneform).then(response => {
  //       	const { phone , name , province} = response.data
		//   		commit('SET_PHONE', phone)
		//   		commit('SET_NAME', name)
		  		
		//   		resolve(phone)
		// 	}).catch(error => {
		// 		reject(error)
		// 	})
		// })
  // },
  

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        removeToken()

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  },
  

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
